<h1 mat-dialog-title>Add Ledger Entry</h1>

<div mat-dialog-content class="dialog-content" [formGroup]="form">
  <mat-form-field appearance="fill">
    <mat-label>Entry Pattern</mat-label>
    <mat-select formControlName="pattern">
      <mat-option *ngFor="let option of patternOptions" [value]="option.value">
        {{option.label}}
      </mat-option>
    </mat-select>
  </mat-form-field>
  <p class="pattern-hint">{{currentPatternHint}}</p>

  <div class="transaction-meta">
    <mat-form-field appearance="fill">
      <mat-label>Source</mat-label>
      <input matInput formControlName="source" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Description</mat-label>
      <input matInput formControlName="description" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>External Reference</mat-label>
      <input matInput formControlName="externalReference" />
    </mat-form-field>

    <mat-form-field appearance="fill">
      <mat-label>Posted At</mat-label>
      <input matInput type="date" formControlName="postedAt" />
    </mat-form-field>
  </div>

  <div class="split-header" *ngIf="!isJournalPattern">
    <mat-form-field appearance="fill" class="anchor-field">
      <mat-label>Main {{anchorSide | titlecase}} Account</mat-label>
      <mat-select formControlName="anchorAccountId">
        <mat-option *ngFor="let account of sortedAccounts" [value]="account.id">
          {{accountLabel(account)}}
        </mat-option>
      </mat-select>
      <mat-error *ngIf="form.get('anchorAccountId')?.invalid && form.get('anchorAccountId')?.touched">
        Main account is required
      </mat-error>
    </mat-form-field>
    <div class="split-note">Split lines below are {{splitSide}} entries.</div>
  </div>

  <div class="rows" formArrayName="rows">
    <div class="row-head">
      <span>Account</span>
      <span>Side</span>
      <span>Amount</span>
      <span>Memo</span>
      <span></span>
    </div>
    <div class="row-item" *ngFor="let row of rowGroups; let i = index" [formGroupName]="i">
      <mat-form-field appearance="fill">
        <mat-select formControlName="accountId" placeholder="Account">
          <mat-option *ngFor="let account of sortedAccounts" [value]="account.id">
            {{accountLabel(account)}}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="fill" *ngIf="isJournalPattern; else fixedSideCell">
        <mat-select formControlName="side" placeholder="Side">
          <mat-option value="debit">Debit</mat-option>
          <mat-option value="credit">Credit</mat-option>
        </mat-select>
      </mat-form-field>
      <ng-template #fixedSideCell>
        <div class="fixed-side">{{splitSide | titlecase}}</div>
      </ng-template>

      <mat-form-field appearance="fill">
        <input matInput type="number" min="0.01" step="0.01" formControlName="amount" placeholder="0.00" />
      </mat-form-field>

      <mat-form-field appearance="fill">
        <input matInput formControlName="memo" placeholder="Optional memo" />
      </mat-form-field>

      <button mat-icon-button type="button" (click)="removeRow(i)" [disabled]="rowGroups.length <= (isJournalPattern ? 2 : 1)">
        <mat-icon>delete</mat-icon>
      </button>
    </div>
  </div>

  <div class="row-actions">
    <button mat-stroked-button type="button" (click)="addRow()">
      {{isJournalPattern ? 'Add Line' : 'Add Split Line'}}
    </button>
  </div>

  <div class="error" *ngIf="errorMessage">{{errorMessage}}</div>
  <div class="empty" *ngIf="!sortedAccounts.length">No accounts found. Create accounts first.</div>
</div>

<div mat-dialog-actions align="end">
  <button mat-button type="button" (click)="cancel()">Cancel</button>
  <button mat-raised-button color="primary" type="button" (click)="save()" [disabled]="!canSubmit">Post Entry</button>
</div>
